export default __webpack_public_path__ + "static/media/sync2.cfa71088.png";